import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { MemoryRouter, Routes, Route } from "react-router-dom";
import Calendar from "@pages/Calendar/Calendar";
import From from "@pages/Form/Form";
import Detail from "@pages/Detail/Detail";
import Settings from "@pages/Settings/Settings";
import Table from "@pages/Table";
import Configurations from "@pages/Configurations";
import Page from "@components/Page";
import ErrorBoundaryLayout from "@components/ErrorBoundaryLayout";
import cs from "./locales/cs.json";
import en from "./locales/en.json";
import { ROOT_ID } from "./constants";
import { LoadingProvider } from "./services/LoadingService";

const rootElement = document.getElementById(ROOT_ID);

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      cs: {
        translation: cs,
      },
      en: {
        translation: en,
      },
    },
    lng: rootElement?.dataset.lang ?? "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

const App = () => (
  <div className="App relative p-2">
    <LoadingProvider>
      <MemoryRouter initialEntries={["/"]}>
        <Routes>
          <Route element={<ErrorBoundaryLayout />}>
            <Route element={<Page />}>
              <Route path="/" element={<Calendar />} />
              <Route path="/table" element={<Table />} />
              <Route path="/configurations" element={<Configurations />} />
            </Route>
            <Route path="/add/:boatId/:date" element={<From />} />
            <Route path="/settings/:boatId/:date" element={<Settings />} />
            <Route path="/detail/:id" element={<Detail />} />
          </Route>
        </Routes>
      </MemoryRouter>
    </LoadingProvider>
  </div>
);

export default App;
